import { render, staticRenderFns } from "./ModalRedactionRejected.vue?vue&type=template&id=025e21a6"
import script from "./ModalRedactionRejected.vue?vue&type=script&lang=ts"
export * from "./ModalRedactionRejected.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports